var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.083 8.48906H14.6747C12.6997 8.48906 11.0913 6.88073 11.0913 4.90573V2.4974C11.0913 2.03906 10.7163 1.66406 10.258 1.66406H6.72467C4.15801 1.66406 2.08301 3.33073 2.08301 6.30573V13.6891C2.08301 16.6641 4.15801 18.3307 6.72467 18.3307H13.2747C15.8413 18.3307 17.9163 16.6641 17.9163 13.6891V9.3224C17.9163 8.86406 17.5413 8.48906 17.083 8.48906Z",
    fill: "#A461D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 1.84207C12.8251 1.5004 12.2334 1.73373 12.2334 2.20873V5.11707C12.2334 6.33373 13.2667 7.34207 14.5251 7.34207C15.3167 7.3504 16.4167 7.3504 17.3584 7.3504C17.8334 7.3504 18.0834 6.79207 17.7501 6.45873C16.5501 5.2504 14.4001 3.0754 13.1667 1.84207Z",
    fill: "#A461D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2329 12.2667C9.99121 12.025 9.59121 12.025 9.34955 12.2667L8.74954 12.8667V9.375C8.74954 9.03333 8.46621 8.75 8.12454 8.75C7.78288 8.75 7.49954 9.03333 7.49954 9.375V12.8667L6.89954 12.2667C6.65788 12.025 6.25788 12.025 6.01621 12.2667C5.77454 12.5083 5.77454 12.9083 6.01621 13.15L7.68288 14.8167C7.69121 14.825 7.69954 14.825 7.69954 14.8333C7.74954 14.8833 7.81621 14.925 7.88288 14.9583C7.96621 14.9833 8.04121 15 8.12454 15C8.20788 15 8.28288 14.9833 8.35788 14.95C8.43288 14.9167 8.49954 14.875 8.56621 14.8167L10.2329 13.15C10.4745 12.9083 10.4745 12.5083 10.2329 12.2667Z",
    fill: "#A461D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDownload);
export default __webpack_public_path__ + "static/media/document-download.acf37c2f5cbe8c94adbc5fb47e44a53e.svg";
export { ForwardRef as ReactComponent };